import React, { useState, useEffect, useRef } from 'react';
import { 
  Phone, 
  MapPin, 
  Clock, 
  ArrowUp, 
  ChevronRight
} from 'lucide-react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Link } from 'react-router-dom';
import { BASE_URL, ENDPOINTS } from '../../apiConfig';
import './Footer.css';

/* ── Inline Brand SVGs (Original Glyphs) ── */
const InstagramIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const FacebookIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const WhatsAppIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
  </svg>
);

const EmailIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0122.25 21H1.75A1.75 1.75 0 010 19.25V4.75C0 3.784.784 3 1.75 3zM22.5 6.438L12.5 13.5 2.5 6.438V19.25c0 .138.112.25.25.25h19.5a.25.25 0 00.25-.25V6.438zM12.5 10.713l9.082-6.463H3.418l9.082 6.463z"/>
  </svg>
);

gsap.registerPlugin(ScrollTrigger);

const Footer = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const footerRef = useRef(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    // Fetch Products and Categories
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const headers = token ? { 'Authorization': `Bearer ${token}` } : {};

        const prodRes = await fetch(`${BASE_URL}${ENDPOINTS.GET_ALL_PRODUCTS}`, { headers });
        const prodData = await prodRes.json();
        const prodItems = Array.isArray(prodData) ? prodData : (prodData?.data || []);
        setProducts(prodItems); // Fetch all, slice in render

        const catRes = await fetch(`${BASE_URL}${ENDPOINTS.GET_ALL_CATEGORIES}`, { headers });
        const catData = await catRes.json();
        const catItems = Array.isArray(catData) ? catData : (catData?.data || []);
        setCategories(catItems); // Fetch all, slice in render
      } catch (error) {
        console.error("Error fetching footer data:", error);
      }
    };
    fetchData();

    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);

    const ctx = gsap.context(() => {
      // Footer columns animation removed for debugging
    }, footerRef);

    return () => {
      ctx.revert();
      window.removeEventListener('resize', handleResize);
    };
  }, []);



  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const displayProducts = products.slice(0, isMobile ? 4 : 7);
  const displayCategories = categories.slice(0, isMobile ? 4 : 7);


  return (
    <footer className="footer-wrap" ref={footerRef}>

      {/* Main Content Grid */}
      <div className="footer-main-content">
        <div className="brand-info-col">
          <div className="brand-logo-wrapper" onClick={scrollToTop}>
            <div className="logo-animation-container">
              <svg width="50" height="50" viewBox="0 0 100 100" fill="none">
                <defs>
                  <linearGradient id="footerLiquidGrad" x1="50%" y1="0%" x2="50%" y2="100%">
                    <stop offset="0%" stopColor="#F1D382" /><stop offset="100%" stopColor="#d4af37" />
                  </linearGradient>
                  <linearGradient id="footerGlassReflection" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="white" stopOpacity="0" />
                    <stop offset="20%" stopColor="white" stopOpacity="0.4" />
                    <stop offset="30%" stopColor="white" stopOpacity="0" />
                  </linearGradient>
                </defs>
                {/* Main Bottle Body with Heavy Glass Base */}
                <rect x="20" y="30" width="60" height="58" rx="6" fill="#0a0a0a" stroke="#d4af37" strokeWidth="1"/>
                <rect x="23" y="33" width="54" height="52" rx="4" fill="url(#footerLiquidGrad)"/>
                {/* Glass Reflections */}
                <rect x="23" y="33" width="54" height="52" rx="4" fill="url(#footerGlassReflection)"/>
                {/* Elegant Neck */}
                <rect x="42" y="24" width="16" height="8" fill="#d4af37"/>
                {/* Luxury Tiered Cap */}
                <rect x="30" y="10" width="40" height="14" rx="2" fill="#d4af37"/>
                {/* Central White Label with Gold Border */}
                <rect x="34" y="42" width="32" height="34" fill="white"/>
                <rect x="36" y="44" width="28" height="30" fill="none" stroke="#d4af37" strokeWidth="1"/>
                {/* The Signature Diagonal Ribbon */}
                <path d="M25 85 L75 35" stroke="black" strokeWidth="4" strokeLinecap="round" opacity="0.8"/>
                {/* Elite Monogram */}
                <text x="50" y="65" fontFamily="'Bodoni Moda', serif" fontSize="24" fill="black" textAnchor="middle" fontWeight="900">E</text>
              </svg>
            </div>
            <h2 className="footer-premium-logo">ESCENTRUM</h2>
          </div>
          <p className="brand-story">
            Born from a passion for olfactory excellence, Escentrum has been curating the world's
            most distinguished fragrances since 2023. We believe that a scent is more than a luxury —
            it is an identity, a memory, and an art form. Each bottle in our collection is a testament
            to master craftsmanship, sourced from the rarest essences across the globe.
          </p>
          <div className="premium-socials">
            <a href="https://www.instagram.com/escentrum_fragrances?igsh=MzhqdmYwYWpnbzdv&utm_source=qr" target="_blank" rel="noopener noreferrer" className="social-btn-premium instagram">
              <InstagramIcon size={20} />
              <span>INSTAGRAM</span>
            </a>
            <a href="https://www.facebook.com/share/1BV9UF5ce2/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="social-btn-premium facebook">
              <FacebookIcon size={20} />
              <span>FACEBOOK</span>
            </a>
            <a href="https://api.whatsapp.com/send?phone=923401854040" target="_blank" rel="noopener noreferrer" className="social-btn-premium whatsapp" title="Chat on WhatsApp">
              <WhatsAppIcon size={20} />
              <span>WHATSAPP</span>
            </a>
            <a href="https://mail.google.com/mail/?view=cm&fs=1&to=escentrumfragrances@gmail.com" target="_blank" rel="noopener noreferrer" className="social-btn-premium email" title="Send an Email">
              <EmailIcon size={20} />
              <span>EMAIL</span>
            </a>
          </div>
        </div>

        <div className="footer-links-col">
          <h4 className="col-header">PRODUCTS</h4>
          <ul className="nav-links-list">
            {displayProducts && displayProducts.length > 0 ? (
              displayProducts.map((product) => (
                <li key={product._id || product.id}>
                  <Link to={`/product/${product._id || product.id}`}>
                    {(product.name || product.productName || 'PRODUCT').toUpperCase()}
                  </Link>
                </li>
              ))
            ) : (
              <li className="no-data-msg">NO PRODUCTS AVAILABLE</li>
            )}
            <li>
              <Link to="/shop" className="view-all-link">
                VIEW ALL <ChevronRight size={14} />
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-links-col">
          <h4 className="col-header">CATEGORIES</h4>
          <ul className="nav-links-list">
            {displayCategories && displayCategories.length > 0 ? (
              displayCategories.map((cat) => (
                <li key={cat._id || cat.id}>
                  <Link to={`/category/${cat._id || cat.id}`}>
                    {(cat.name || cat.categoryName || 'CATEGORY').toUpperCase()}
                  </Link>
                </li>
              ))
            ) : (
              <li className="no-data-msg">NO CATEGORIES AVAILABLE</li>
            )}
            <li>
              <Link to="/shop" className="view-all-link">
                VIEW ALL <ChevronRight size={14} />
              </Link>
            </li>
          </ul>
        </div>

        <div className="contact-col">
          <h4 className="col-header">VISIT US</h4>
          <div className="contact-details">
            <a 
              href="https://www.google.com/maps/search/?api=1&query=Afsar+khan+plaza+1st+floor+shop+23+Tank+kpk" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="detail-row"
            >
              <div className="detail-icon-box"><MapPin size={22} /></div>
              <div className="detail-text">
                <span className="detail-label">BOUTIQUE</span>
                <span className="detail-value">Afsar khan plaza 1st floor shop 23 Tank kpk</span>
              </div>
            </a>
            <a href="tel:03401854040" className="detail-row">
              <div className="detail-icon-box"><Phone size={22} /></div>
              <div className="detail-text">
                <span className="detail-label">CONTACT NUMBER</span>
                <span className="detail-value">03401854040</span>
              </div>
            </a>
            <a href="https://mail.google.com/mail/?view=cm&fs=1&to=escentrumfragrances@gmail.com" target="_blank" rel="noopener noreferrer" className="detail-row">
              <div className="detail-icon-box"><EmailIcon size={22} /></div>
              <div className="detail-text">
                <span className="detail-label">EMAIL</span>
                <span className="detail-value">escentrumfragrances@gmail.com</span>
              </div>
            </a>
            <div className="detail-row">
              <div className="detail-icon-box"><Clock size={22} /></div>
              <div className="detail-text">
                <span className="detail-label">HOURS</span>
                <span className="detail-value">MON-SAT: 10AM - 8PM</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom-bar">
        <div className="bottom-bar-container">
          <p className="copyright-text">
            © 2023 ESCENTRUM FRAGRANCES. ALL RIGHTS RESERVED.
            <span className="dev-credit">DEVELOPED BY <a className="dev-name" href="https://www.brainexworld.com/" target="_blank" rel="noopener noreferrer">BRAINEX WORLD PVT. LTD</a></span>
          </p>
          <nav className="legal-nav">
            <Link to="/privacy-policy">PRIVACY POLICY</Link>
            <Link to="/terms-of-use">TERMS OF USE</Link>
            <Link to="/cookies-policy">COOKIES</Link>
          </nav>
          <button className="scroll-up-trigger" onClick={scrollToTop} aria-label="Scroll to top">
            <ArrowUp size={24} color="#0a0a0a" />
          </button>
        </div>
      </div>

    </footer>
  );
};

export default Footer;